import { FontIcon, Stack } from "@fluentui/react";
import { useEffect } from "react";
import { useAppContext } from "./AppContext";
import React from "react";
import Categories from "./Categories";
import Corporations from "./Corporations";
import Stores from "./Merchants";

export default function HomeScreen() {

    const {appData, setAppData} = useAppContext(); // <-- get context method

    useEffect(() => {
    // Initialize userEmail and userId from localStorage or set defaults
    const storedEmail = localStorage.getItem('signed_in_email') || '';
    const storedUserId = localStorage.getItem('signed_in_id') || '';

    if (storedEmail || storedUserId) {
        setTimeout(() => {
        //window.location.href = '/Reports';
        }, 2000);

    }
    }, []);

    return (
        <div className="HomeScreen" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh', overflowY: 'hidden' }}>
            <span style={{ fontSize: '2.5em' }}>
                sConscious <FontIcon aria-label="Shop" iconName="Shop" className="FontIcon" />
            </span>
        </div>  
    )
}